"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/status_tracker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusTracker = function StatusTracker(_ref) {
  var current = _ref.current,
      items = _ref.items;
  return _react.default.createElement("div", {
    className: "vn-status-tracker"
  }, items.reduce(function (acc, item, index, array) {
    var currentIndex = array.indexOf(current);
    var dotClassName = (0, _classnames.default)({
      'vn-status-tracker__step-dot': true,
      'vn-status-tracker__step-dot--active': index <= currentIndex
    });
    var labelClassName = (0, _classnames.default)({
      'vn-status-tracker__step-label': true,
      'vn-status-tracker__step-label--active': index <= currentIndex
    });
    var barClassName = (0, _classnames.default)({
      'vn-status-tracker__bar': true,
      'vn-status-tracker__bar--active': index < currentIndex
    });
    var isNotLast = index !== array.length - 1;
    var barCount = array.length - 1; // split the 100% width among each bar
    // and also split the 10px from the first dot left half
    // plus the 10px from the last dot right half

    var barWidth = "calc(".concat(100 / barCount, "% - ").concat(20 / barCount, "px)");
    acc.push(_react.default.createElement("div", {
      key: "step-".concat(item),
      className: "vn-status-tracker__step"
    }, _react.default.createElement("div", {
      className: dotClassName
    }), _react.default.createElement("div", {
      className: labelClassName
    }, item)));

    if (isNotLast) {
      acc.push(_react.default.createElement("div", {
        key: "bar-".concat(item),
        className: barClassName,
        style: {
          width: barWidth
        }
      }));
    }

    return acc;
  }, []));
};

StatusTracker.propTypes = {
  current: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired
};
StatusTracker.displayName = 'StatusTracker';
var _default = StatusTracker;
exports.default = _default;
